import { observer } from "mobx-react-lite";
import { FC } from "react";
import { FileUploadRejectedModalStore } from "@/components/modal/file-upload-rejected/file-upload-rejeted-modal-store";
import {
  MDSButton,
  MDSButtonVariant,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSModalDialog,
  MDSText,
  MDSTextVariant,
  MDSTextWeight,
} from "@/mds";
import { MDSButtonGroup } from "@/mds/components/buttons/button-group";

export interface FileUploadRejectedModalProps {
  store: FileUploadRejectedModalStore;
}

export const FileUploadRejectedModal: FC<FileUploadRejectedModalProps> = observer(({ store }) => {
  return (
    <MDSModalDialog isOpen={store.isOpen} handleClose={() => store.close()}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        This file is too large to upload
      </MDSText>
      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphSm}>
          <MDSText as="span" variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Medium}>
            {store.truncatedFileName}
          </MDSText>{" "}
          exceeds the {store.fileSizeLimitMb}MB file size limit. Try compressing the file or
          splitting it into smaller parts.
        </MDSText>
      </MDSDialogTextContent>
      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton variant={MDSButtonVariant.Contrast} onClick={() => store.close()}>
          Got it
        </MDSButton>
      </MDSButtonGroup>
    </MDSModalDialog>
  );
});
